<template>
  <v-col cols="12" :order="order">
    <v-overlay :value="isLoading" opacity="1">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-card
      class="mx-auto"
      max-width="600"
      :width="$vuetify.breakpoint.mdAndUp ? '80%' : '100%'"
    >
      <v-card-title
        class="primary white--text mt-5"
        v-text="`${type} - ${name}`"
      ></v-card-title>

      <v-speed-dial
        v-model="fab"
        absolute=""
        top
        right
        direction="bottom"
        :open-on-hover="true"
        transition="scale"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-btn
          @click="downloadFile({ url: item, name: name, ext: ext })"
          fab
          color="blue"
          small
          ><v-icon>mdi-download</v-icon></v-btn
        >
        <v-btn fab color="blue" small :href="item" target="_blank"
          ><v-icon>mdi-open-in-new</v-icon></v-btn
        >
        <v-btn
          :disabled="!$store.getters['auth/reliabilityWrite']"
          fab
          dark
          small
          color="#730D0B"
          @click="onDelete"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-speed-dial>
      <v-img aspect-ratio="1" v-if="type === 'image'" :src="item"></v-img>
      <vue-plyr v-if="type === 'video'">
        <video :src="item">
          <source :src="item" :type="`video/${ext}`" size="720" />
        </video>
      </vue-plyr>
      <vue-plyr v-if="type === 'audio'">
        <audio :src="item">
          <source :src="item" :type="`audio/${ext}`" />
        </audio>
      </vue-plyr>
    </v-card>
  </v-col>
</template>

<script>
import downloadLogic from "@/mixins/downloadLogic";
export default {
  mixins: [downloadLogic],
  props: ["item", "index"],
  data: () => ({
    type: "",
    name: "",
    ext: "",
    isLoading: false,
    fab: false
  }),
  mounted: function() {
    const arrayLink = this.item.split("%2F");
    this.type = arrayLink[2];
    const getName = arrayLink[3].split(".");
    this.name = getName[0];
    const getExtension = getName[1].split("?");
    this.ext = getExtension[0];
  },
  computed: {
    cols() {
      return 12;
    },
    order: function() {
      return this.type === "video" ? 1 : this.type === "audio" ? 2 : 3;
    }
  },
  methods: {
    onDelete: function() {
      this.$emit("remove");
      this.$emit(
        "delete",
        this.item,
        this.type,
        `${this.name}.${this.ext}`,
        this.index
      );
    }
  }
};
</script>
